import { valuePairToValue } from '@softpak/components/spx-helpers';
import { ExtRfrMonStackQueryI } from './rfr-mon-stack.query.ext';
import { RfrMonStackQueryI } from './rfr-mon-stack.query.int';
import { ExtRfrMonStackI } from './rfr-mon-stack.result.ext';
import { RfrMonStackResponseI } from './rfr-mon-stack.result.int';

export const MapRfrMonStack = {
    mapQuery: (int: RfrMonStackQueryI): ExtRfrMonStackQueryI => {
      const filters = [{
          field: 'stackcode',
          operator: 'eq',
          value: encodeURIComponent(valuePairToValue(int.stackCode)),
      }];
      if (int.containerSeqNr) {
          filters.push({
              field: 'seqnr',
              operator: 'eq',
              value: encodeURIComponent(valuePairToValue(int.containerSeqNr)),
          });
      }

      return {
          request: {
              filter: JSON.stringify({
                  logic: 'and',
                  filters: [...filters],
              })
          }
      };
    },
    mapResult: (ext: ExtRfrMonStackI): RfrMonStackResponseI => (
    {
      containers: ext.response.dsdp_container?.ttdp_container?.map(container => ({
        boxref4: container.boxref4,
        boxref5: container.boxref5,
        calc_customer_shortname: container.calc_customer_shortname,
        calc_cyclus: container.calc_cyclus,
        calc_dt_last_check: container.calc_dt_last_check,
        calc_in_vessel: container.calc_in_vessel,
        calc_out_vessel: container.calc_out_vessel,
        calc_stackcode: container.calc_stackcode,
        calc_subcustomer_shortname: container.calc_subcustomer_shortname,
        calc_tim_last_check: container.calc_tim_last_check,
        calc_todo: container.calc_todo,
        containernumber: container.containernumber,
        containerprefix: container.containerprefix,
        humidity: container.humidity,
        ind_CA: container.ind_CA,
        ind_defrosting: container.ind_defrosting,
        remarks: container.remarks,
        seqnr: container.seqnr,
        stacklocation: container.stacklocation,
        temperature_max_deviation: container.temperature_max_deviation,
        temperature: container.temperature,
        ventilation: container.ventilation,
        departure: container.dt_etd,
        imo_lines: (container.ttdp_container_imo ? container.ttdp_container_imo : []).map(imoLine => ({
          imo_seqnr: imoLine.imo_seqnr,
          unno: imoLine.unno,
          kemlergroupcode: imoLine.kemlergroupcode,
          description: imoLine.des,
          class: imoLine.class,
          flashpoint: imoLine.flashpoint,
        })),
      }))
  }),
};
